import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CustomViewPage from '../../../components/CustomComponents/CustomViewPage'

import { useTrainingCategory } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategory'

import { formatDate } from '../../../shared/constants'
import ViewImage from '../../../components/ViewImage'
export default function ViewTrainingCategory() {
  const { getTrainingCategory, trainingCategory, loading } = useTrainingCategory()
  const params = useParams()

  const [data, setData] = useState([])

  useEffect(() => {
    getTrainingCategory({ _id: params.trainingCategoryId })
  }, [params.trainingCategoryId])

  useEffect(() => {
    if (trainingCategory) {
      setData([
        { label: 'Training Category Code', data: trainingCategory.trainingCategoryCode },
        { label: 'Name', data: `${trainingCategory.name}` },
        { label: 'Minimum Percentage', data: trainingCategory.minimumPercentage + ' %' },
        { label: 'Retest Frequency', data: trainingCategory.retestFrequency + ' Days' },
        { label: 'Thumbnail', data: <ViewImage image={trainingCategory.image} /> },
      ])
    }
  }, [trainingCategory])
  return <CustomViewPage loading={loading} heading="Training Category" editUrl="training-category" id={params.trainingCategoryId} redirect="ALL_TRAININGCATEGORY" data={data} />
}
